// Core packages
import { Component, Inject, OnInit } from '@angular/core';

// Third party packages
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Custom packages

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {
  showBnt = false;
  chekboxShowAgain = false;
  notShowAgain = false;
  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit() {
    // Set default icons if none are provided
    if (!this.data.btnOkIcon) {
      this.data.btnOkIcon = 'fa-check-circle';
    }
    if (!this.data.btnCancelIcon) {
      this.data.btnCancelIcon = 'fa-times-circle';
    }

    // Set default button colors if none are provided
    if (!this.data.btnOkColor) {
      this.data.btnOkColor = 'primary';
    }
    if (!this.data.btnCancelColor) {
      this.data.btnCancelColor = 'warn';
    }

    if (this.data.showBnt) {
      this.showBnt = this.data.showBnt;
    }
    
    if (this.data.chekboxShowAgain) {
      this.chekboxShowAgain = this.data.chekboxShowAgain;
    }
  }

  /**
   * Handle click on Denial button
   *
   * @since 1.0.0
   */
  onDenial(): void {
    this.dialogRef.close({
      notShowAgain: this.notShowAgain
    });
  }
    
  /**
   * Handle select all topics
   *
   * @since 1.0.0
   */
  onShowAgain(checked: boolean): void {
    this.notShowAgain = checked;
  }
}
